"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignatureValidator = void 0;
const eth_connect_1 = require("eth-connect");
async function SignatureValidator(requestManager, address) {
  const abi = [{
    constant: true,
    inputs: [{
      name: 'hash',
      type: 'bytes32'
    }, {
      name: '_signature',
      type: 'bytes'
    }],
    name: 'isValidSignature',
    outputs: [{
      name: 'magicValue',
      type: 'bytes4'
    }],
    payable: false,
    stateMutability: 'view',
    type: 'function'
  }];
  return await new eth_connect_1.ContractFactory(requestManager, abi).at(address);
}
exports.SignatureValidator = SignatureValidator;